<template>
  <Section
    decoration="/images/dots.svg"
    :index="1"
    :title="t('sections.about')"
    id="about"
  >
    <div class="about">
      <div class="about__picture">
        <img
          src="/images/profile.webp"
          class="about__image"
          loading="lazy"
          alt=""
        >
      </div>
      <div>
        <h2 class="about__headline">
          {{ t('about.headline') }}
        </h2>
        <p
          v-for="(paragraph, index) in paragraphs"
          :key="index"
          class="about__paragraph"
        >
          {{ paragraph }}
        </p>
      </div>
    </div>
  </Section>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Section from '@/ui/Section.vue';

const { t, tm } = useI18n();

const programming = new Date().getFullYear() - 2011;
const professional = new Date().getFullYear() - 2018;

const paragraphs = computed<string[]>(() => tm('about.paragraphs')
  .map((paragraph: string) => paragraph
    .replace('{programming}', programming.toString())
    .replace('{professional}', professional.toString()),
  ),
);
</script>

<style lang="scss" scoped>
@use '@/styles/screens';

.about {
  display: grid;
  gap: 24px;

  @include screens.desktop {
    grid-template-columns: 300px auto;
  }
}

.about__picture {
  position: relative;
  height: 240px;
  width: 90%;
  
  @include screens.tablet {
    width: 280px;
  }
  
  @include screens.desktop {
    height: 300px;
    width: 100%;
  }
}

.about__picture::before {
  content: '';
  background: url('/images/blob.svg');
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  opacity: 0.5;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.about__image {
  display: block;
  mask-image: url('/images/blob.svg');
  mask-repeat: no-repeat;
  mask-position: 20% bottom;
  mask-size: contain;
  position: relative;
  height: 100%;

  @include screens.desktop {
    width: 100%;
  }
}

.about__headline {
  color: var(--color-text-strong);
  font-family: var(--font-family-display);
  font-weight: 500;
  font-size: 24px;
}

.about__paragraph {
  margin-top: 24px;
  
  @include screens.tablet {
    font-size: 18px;
  }
}
</style>
